export default {
  "config": {
    "trial": "driving",
    "id": "secondary-endpts",
    "type": "table",
    "title": "Additional SDLP Secondary Endpoints Including Standard Deviation of Speed, Number of Driving Lapses and THAT<sup>29</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup> </no-break>",
      "<no-break><sup>a</sup>Solriamfetol – placebo.</no-break>",
      "<sup>b</sup><em>P</em> values are nominal; repeated mixed-effects analysis of variance.",
      "Secondary measures of driving performance were not different between solriamfetol and placebo at either time point.",
      "THAT scores at the end of each treatment period indicated greater alertness with solriamfetol compared with placebo."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "driving",
    "id": "secondary-endpts",
    "data-type": "table",
    "title": "Additional SDLP Secondary Endpoints Including Standard Deviation of Speed, Number of Driving Lapses and THAT<sup>29</sup>",
    "num-header-rows": 3,
    "num-columns": 7,
    "col-classes": [
      "col-1",
      "pbo",
      "pbo",
      "sol",
      "sol",
      "diff",
      "pvalue"
    ],
    "row-mergeoption": [
      1,
      2,
      3,
      6,
      9
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a",
      "footnote-b",
      "footnote-note2",
      "footnote-note3"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup> </no-break>",
    "footnote-a": "<no-break><sup>a</sup>Solriamfetol – placebo.</no-break>",
    "footnote-b": "<sup>b</sup><em>P</em> values are nominal; repeated mixed-effects analysis of variance.",
    "footnote-note2": "Secondary measures of driving performance were not different between solriamfetol and placebo at either time point.",
    "footnote-note3": "THAT scores at the end of each treatment period indicated greater alertness with solriamfetol compared with placebo.",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Placebo</b></center>",
          "cols": 2,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b>Solriamfetol</b></center>",
          "cols": 2,
          "class": "sol"
        },
        {
          "content": null,
          "cols": 2,
          "class": "diff"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>Time point</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>n</b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b><no-break>LS mean (SE)</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>n</b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b><no-break>LS mean (SE)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>LS mean difference<sup>a</sup> <no-break>(95% CI)</no-break></b>",
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "<b><em>P</em> value<sup>b</sup></b>",
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Standard deviation of speed, km/h",
          "cols": 7,
          "class": "col-1",
          "parentRow": true,
          "parent": 2
        }
      ],
      "row-3": [
        {
          "indent": 1,
          "parent": 2,
          "content": "2 h postdose",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 33,
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2.55 (0.10)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 34,
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2.62 (0.10)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.1 <no-break>(–0.10, 0.23)</no-break>",
          "parent": 2,
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.412",
          "parent": 2,
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-4": [
        {
          "indent": 1,
          "parent": 2,
          "content": "6 h postdose",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "32",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2.84 (0.10)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "32",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2.73 (0.10)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.1</no-break> <no-break>(–0.28, 0.06)</no-break>",
          "parent": 2,
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.199",
          "parent": 2,
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Number of driving lapses (prolonged lane drifts)",
          "cols": 7,
          "class": "col-1",
          "parentRow": true,
          "parent": 5
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 5,
          "content": "2 h postdose",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "33",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2.89 (0.57)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "34",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1.76 (0.56)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<no-break>–1.1</no-break> <no-break>(–2.40, 0.14)</no-break>",
          "parent": 5,
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.081",
          "parent": 5,
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-7": [
        {
          "indent": 1,
          "parent": 5,
          "content": "6 h postdose",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "32",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2.07 (0.57)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "32",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2.12 (0.57)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "0.1 <no-break>(–1.25, 1.35)</no-break>",
          "parent": 5,
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.939",
          "parent": 5,
          "cols": 1,
          "class": "pvalue"
        }
      ],
      "row-8": [
        {
          "indent": 0,
          "content": "THAT (higher score indicates greater alertness)",
          "cols": 7,
          "class": "col-1",
          "parentRow": true,
          "parent": 8
        }
      ],
      "row-9": [
        {
          "indent": 1,
          "parent": 8,
          "content": "End of treatment period",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "33",
          "parent": 8,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "23.9 (1.2)",
          "parent": 8,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "34",
          "parent": 8,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "27.5 (1.2)",
          "parent": 8,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3.6 <no-break>(0.50, 6.66)</no-break>",
          "parent": 8,
          "cols": 1,
          "class": "diff"
        },
        {
          "indent": 0,
          "content": "0.024",
          "parent": 8,
          "cols": 1,
          "class": "pvalue"
        }
      ]
    }
  }
};